
class ScannerFirmwareUpdateError extends Error {
    constructor(...args) {
        super(...args);
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, ScannerFirmwareUpdateError);
        }
    }
}


class ScannerFirmwareUpdateFailure extends ScannerFirmwareUpdateError {
    constructor(xVerbiage, xDetails = []) {
        super(xVerbiage);
        this.details = xDetails;
    }

    get verbiage() {
        return super.message;
    }

    get detailLogs() {
        return [...this.details];
    }

    getDetailLogs() {
        return [...this.details];
    }
}


class FirmwareNotCompatibleError extends ScannerFirmwareUpdateError {
    constructor(...args) {
        super(...args);
        // Error.captureStackTrace(this, FirmwareNotCompatibleError)
    }
}


class ScannerNotConnectedError extends ScannerFirmwareUpdateError {
    constructor(...args) {
        super(...args);
        // Error.captureStackTrace(this, FirmwareNotCompatibleError)
    }
}

export {ScannerFirmwareUpdateError, ScannerFirmwareUpdateFailure, FirmwareNotCompatibleError, ScannerNotConnectedError};
